<template>
  <v-container fluid class="AditionalModules-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
    <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
      <v-col md="2" class="smartbell-smartbellLeftSideDesktop" v-if="userData.onboarding === true">

      </v-col>
      <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}" class="UserType-rightAllPlans">
        <v-row justify="center" align="center">
          <v-col md="3" class="UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#65D9AC">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h4>Finánzas</h4> <img src="../assets/icons/money.svg" alt="" class="AditonalModules-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price">
                  <span class="UserType-priceTextLeft">$ 1,499</span><span>Anual</span>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>50 vacas</strong></li>
                    <li>Alertas via e-mail</li>
                    <li>Soporte técnico en 72hrs</li>
                    <li><strong>1 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="AditionalModules-buttonNormal">Lista de espera</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col md="3" offset-md="1" class="UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#65D9AC">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h3>Aretes inteligentes</h3> <img src="../assets/icons/earings.svg" alt="" class="AditonalModules-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price AditionalModule-earingPrice">
                  <span class="UserType-priceTextLeft">$ 89*</span><br><span>MX/Mes/Vaca</span>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>150 vacas</strong></li>
                    <li>Alertas via e-mail y SMS</li>
                    <li>Soporte técnico en 48hrs</li>
                    <li><strong>3 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="AditionalModules-buttonRed">Lista de espera</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col md="3" offset-md="1" class="UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#65D9AC">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h4>Genétia</h4><img src="../assets/icons/cowsGenetics.svg" alt="" class="AditonalModules-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price">
                  <span class="UserType-priceTextLeft">$ 1,989</span><span>Anual</span>
                  <br>
                  <br>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>150 vacas</strong></li>
                    <li>Alertas via 4 canales</li>
                    <li>Soporte técnico 24/7</li>
                    <li><strong>5 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="AditionalModules-buttonNormal">Lista de espera</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" class="UserType-aditionaButtons">
          <v-col md="3" class="UserType-noPadding">
            <v-col md="12" class="UserType-button UserType-noPadding UserType-priceInfo">

            </v-col>
          </v-col>
          <v-col md="3" offset-md="1" class="UserType-noPadding">
            <v-col md="12" class="UserType-button UserType-noPadding">

            </v-col>
          </v-col>
          <v-col md="3" offset-md="1">
            <v-col md="12" class="UserType-button">
              <v-btn class="AditionalUser-userPlans smartbell-buttonCorrection" @click="openNormalModules()">Planes de membresía</v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-footer color="#F9FDFE" padless class="smartbell-footer">
          <v-row justify="center" no-gutters>
              <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
              </v-col>
          </v-row>
      </v-footer>
    </v-row>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue'
export default {
  name: 'AditionalModules',
    data () {
      return {
      }
  },
  components: {
        NavBar
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    },
    animals() {
      return this.$store.getters.getAnimals;
    },
  },
  methods: {
     openNormalModules(){
      this.$router.push({name:'UserType'})
    }
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/AditionalModules.css';
</style>
